import {
    Box,
    Container,
    Grid,
    Typography
} from "@mui/material";
import { useState } from "react";

import LinkRouter from "../../components/LinkRouter";

import { logo } from "../../assets/logos";
import { instagram, telegram, tiktok, facebook } from "../../assets/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { fb, inst, tg, tt } from "../../assets/links";


interface IAppBarItem {
    lable: string,
    path: string,
}

const Footer = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [firstPages, setFirstPages] = useState<Array<IAppBarItem>>([
        { lable: 'Головна', path: '/' },
        { lable: 'Про нас', path: '/about-us' },
    ]);
    const [secondPages, setSecondPages] = useState<Array<IAppBarItem>>([
        { lable: 'Анонси', path: '/announcements' },
        { lable: 'Як проводим?', path: '/how-is-event-going' },
        { lable: 'Проєкти', path: '/projects' },
    ]);
    const [socialMedia, setSocialMedia] = useState<Array<IAppBarItem>>([
        { lable: telegram, path: tg },
        { lable: instagram, path: inst },
        { lable: tiktok, path: tt },
        { lable: facebook, path: fb },
    ]);

    return (
        <Box component="footer" sx={{ borderTop: (theme) => `1px solid ${theme.palette.primary.light}` }}>
            <Container sx={{ maxWidth: { lg: "1310px", md: "744px", xs: "350px" } }}>
                <Grid container spacing={0} columns={{ xs: 4, md: 5, lg: 12 }} sx={{ height: "100%", display: "flex", pt: "40px", pb: "27px" }}>
                    <Grid item xs={4} md={2} sx={{ display: "flex", flexDirection: "column", alignItems: { xs: "center", md: "start" } }}>
                        <LinkRouter underline="none" color="unset" to="/" sx={{ width: "200px", height: "34px" }}>
                            <img
                                loading="lazy"
                                style={{ width: "inherit", height: "inherit" }}
                                src={logo}
                                alt="logo"
                            />
                        </LinkRouter>
                        <Typography variant="h4" fontFamily="Fixel Display" sx={{ typography: { xs: "h5", lg: "h4" }, mt: { xs: "24px", lg: "50px" } }}>
                            +(380) 68-84-48-358
                        </Typography>
                    </Grid>
                    <Grid item xs={2} sx={{ display: { xs: "none", lg: "block" } }} />
                    <Grid item xs={4} md={2} lg={4} sx={{ display: "flex", justifyContent: { xs: "space-around", md: "space-between" }, mt: { xs: "34px", md: "0px" }, pl: { xs: "30px", md: "0px" } }}>
                        <Box sx={{ ml: { xs: "0px", lg: "50px" } }}>
                            {firstPages.map((page, index) => (
                                <LinkRouter underline="none" color="unset" to={page.path}>
                                    <Typography variant="h4" fontFamily="Fixel Display" sx={{ mb: ((firstPages.length - 1) !== index ? { xs: "16px", md: "12px" } : "0px") }}>
                                        {page.lable}
                                    </Typography>
                                </LinkRouter>
                            ))}
                        </Box>
                        <Box sx={{ ml: { xs: "0px", lg: "40px" } }}>
                            {secondPages.map((page, index) => (
                                <LinkRouter underline="none" color="unset" to={page.path}>
                                    <Typography variant="h4" fontFamily="Fixel Display" sx={{ mb: ((secondPages.length - 1) !== index ? { xs: "16px", md: "12px" } : "0px") }}>
                                        {page.lable}
                                    </Typography>
                                </LinkRouter>
                            ))}
                        </Box>
                    </Grid>
                    <Grid item xs={1} sx={{ display: { xs: "none", lg: "block" } }} />
                    <Grid item xs={4} md={1} lg={3} sx={{ display: "flex", flexWrap: "wrap", justifyContent: { xs: "space-around", md: "end" }, mt: { xs: "43px", md: "0px" }, px: { xs: "54px", md: "0px" } }}>
                        {socialMedia.map((item, index) => (
                            <Box
                                key={`social_media_${index}`}
                                sx={{
                                    width: "40px",
                                    height: "40px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    border: (theme) => `1px solid ${theme.palette.primary.main}`,
                                    borderRadius: "5px",
                                    ml: { md: "12px", lg: "24px" },
                                    cursor: "pointer"
                                }}
                                onClick={() => { window.open(item.path) }}
                            >
                                <Box sx={{ width: "24px", height: "24px" }}>
                                    <img
                                        loading="lazy"
                                        style={{ width: "inherit", height: "inherit" }}
                                        src={item.lable}
                                        alt={`social_media_${index}`}
                                    />
                                </Box>
                            </Box>
                        ))}
                    </Grid>
                    <Grid item xs={4} md={5} lg={12} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Box sx={{ display: "flex", justifyContent: "center", flexWrap: "wrap", mt: "60px" }}>
                            <Typography variant="h5" fontFamily="Fixel Display" >
                                © 2014-2024 AboutUkraine.
                            </Typography>
                            <Box sx={{ display: "flex" }}>
                                <Typography variant="h5" fontFamily="Fixel Display" sx={{ textDecoration: "underline", cursor: "pointer", mx: "5px" }} onClick={() => { window.open(`${location.pathname.split("/")[0]}/files/Договір оферти.docx.pdf`) }}>
                                    Договір оферта.
                                </Typography>
                                <Typography variant="h5" fontFamily="Fixel Display" sx={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => { window.open(`${location.pathname.split("/")[0]}/files/Статут.pdf`) }}>
                                    Статут.
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: "flex" }}>
                            <Typography variant="h5" fontFamily="Fixel Display" sx={{ textDecoration: "underline", cursor: "pointer", mr: "5px" }} onClick={() => { window.open(`${location.pathname.split("/")[0]}/files/Витяг ЄДР.pdf`) }}>
                                Витяг ЄДР.
                            </Typography>
                            <Typography variant="h5" fontFamily="Fixel Display" sx={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => { window.open(`${location.pathname.split("/")[0]}/files/Довідка про неприбутковість.pdf`) }}>
                                Довідка про неприбутковість.
                            </Typography>
                        </Box>
                        <Typography variant="h5" fontFamily="Fixel Display" color="primary.light" sx={{ pt: "18px", cursor: "pointer" }} onClick={() => { window.open("https://www.instagram.com/kova.design_studio/") }}>
                            created by kova.design studio
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </Box >
    );
}

export default Footer;